import * as React from 'react';
import { clsx } from 'clsx';

interface Props extends React.ComponentPropsWithoutRef<"div"> {}

function AssetInfoPill({className = '', children, ...otherProps}: Props) {
	return (<>
		<div className={clsx(className, "bg-black/70 text-white inline-block px-1.5 py-0.5 rounded-sm")} {...otherProps}>
			{children}
		</div>
	</>);
}

export default AssetInfoPill;
